import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
Vue.prototype.$fb = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL
});
Vue.prototype.$auth = firebase.auth();
Vue.prototype.$db = firebase.database();

import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
Vue.use(VueI18n)
Vue.use(VueCookie)
const i18n = new VueI18n({
  locale: VueCookie.get('lang') || process.env.VUE_APP_DEFAULT_LANGUAGE,
  fallbackLocale: process.env.VUE_APP_DEFAULT_LANGUAGE,
  messages: {
    'en': require('./lang/en'),
    'zh-TW': require('./lang/zh-TW')
  }
});

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

import router from './router'
router.beforeEach(function(to, from, next) {
  window.scrollTo(0, 0)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        if (to.name === 'Login') {
          next({
            path: to.query.redirect || '/'
          });
        } else {
          next();
        }
      } else {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      }
    });
  } else {
    next();
  }
});

import '@mdi/font/css/materialdesignicons.css'

new Vue({
  i18n,
  router,
  icons: {
    iconfont: 'mdi'
  },
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: process.env.VUE_APP_PRIMARY_COLOR,
          secondary: process.env.VUE_APP_SECONDARY_COLOR,
          accent: process.env.VUE_APP_ACCENT_COLOR
        }
      }
    }
  }),
  render: h => h(App),
  created() {
    document.title = this.$t('app_name');
  },
  data() {
    return {
      userAuth: null,
      userDevice: {},
      userDeviceLoading: null,
      userDeviceOnline: {},
      userTemperatureUnit: null
    }
  }
}).$mount('#app')